const cutHex = h => ((h.charAt(0) === '#') ? h.substring(1, 7) : h)
const hexToR = h => parseInt((cutHex(h)).substring(0, 2), 16)
const hexToG = h => parseInt((cutHex(h)).substring(2, 4), 16)
const hexToB = h => parseInt((cutHex(h)).substring(4, 6), 16)


export const colourContrast = (hex) => {
  const threshold = 128
  const hRed = hexToR(hex)
  const hGreen = hexToG(hex)
  const hBlue = hexToB(hex)

  const cBrightness = ((hRed * 299) + (hGreen * 587) + (hBlue * 114)) / 1000

  return cBrightness > threshold ? '#111' : '#fff'
}
